import { render, staticRenderFns } from "./PasswordRecoveryPage.vue?vue&type=template&id=b1ec23e8&scoped=true"
import script from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PasswordRecoveryPage.vue?vue&type=style&index=1&id=b1ec23e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ec23e8",
  null
  
)

export default component.exports